import { render, staticRenderFns } from "./SystemAccessControl.vue?vue&type=template&id=9e33a0d4&scoped=true&"
import script from "./SystemAccessControl.vue?vue&type=script&lang=js&"
export * from "./SystemAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e33a0d4",
  null
  
)

export default component.exports